export default "__VITE_ASSET__Dy4WaO0x__"